// removed by extract-text-webpack-plugin
module.exports = {"pricingTableDiv":"_32CmvnWpawDpO56aBT4g6o"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/snapsell/PricingTableSection.scss
// module id = 1607
// module chunks = 0